import { useState } from "react";
import { signUp } from "../../services/users";
import { useNavigate, Link } from "react-router-dom";
import "./SignUp.css";
import Layout from "../../components/Layout/Layout";

function SignUp(props) {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    username: "",
    email: "",
    password: "",
    isError: false,
    errorMsg: "",
  });

  const handleChange = (e) =>
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });

  const onSignUp = async (event) => {
    event.preventDefault();
    const { setUser } = props;
    try {
      const user = await signUp(form);
      setUser(user);
      navigate("/");
    } catch (error) {
      console.error(error);
      setForm({
        username: "",
        email: "",
        password: "",
        isError: true,
        errorMsg: "Sign Up Details Invalid",
      });
    }
  };

  const renderError = () => {
    const toggleForm = form.isError ? "danger" : "";
    if (form.isError) {
      return (
        <button type="submit" className={toggleForm}>
          {form.errorMsg}
        </button>
      );
    } else {
      return (
        <div>
          <button className="signup-button" type="submit">
            Sign Up
          </button>
        </div>
      );
    }
  };

  const { username, email, password } = form;

  return (
    <Layout user={props.user}>
      <div className="signup-container">
        <div className="signup-helper">
          <h3 className="signup-text">Create Account</h3>
          <h3 className="signup-helper-sub">
            Do you have an account?
            <br />
            <br />
            <Link
              to="/sign-in"
              style={{ textDecoration: "none", color: "#006d77" }}
            >
              Sign In
            </Link>
          </h3>
        </div>
        <div>
          {" "}
          <div className="header-signup">
            <h3 className="signup">Sign Up</h3>
          </div>
          <form className="signup-form" onSubmit={onSignUp}>
            <label className="signup-label">Username: </label>
            <input
              required
              className="signup-input"
              type="text"
              name="username"
              value={username}
              placeholder="Enter Username"
              onChange={handleChange}
            />
            <label className="signup-label">Email: </label>
            <input
              required
              className="signup-input"
              type="email"
              name="email"
              value={email}
              placeholder="Enter Email"
              onChange={handleChange}
            />
            <label className="signup-label">Password: </label>
            <input
              required
              className="signup-input"
              name="password"
              value={password}
              type="password"
              placeholder="Password"
              onChange={handleChange}
            />
            {renderError()}
          </form>
        </div>
      </div>
    </Layout>
  );
}

export default SignUp;
